import React, { useState, useEffect } from "react";


const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    {
      title: "Crafting Excellence In Code:",
      subtitle:
        "Transform Your Business With Our Software Development Services",
    },
    {
      title: "Innovative Solutions:",
      subtitle: "Building Tomorrow's Technology Today",
    },
    {
      title: "Your Success Partner:",
      subtitle: "Expert Development Team At Your Service",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  

  return (
    <div
      id="home"
      className="relative h-screen my-4 overflow-x-hidden"
      style={{
        backgroundImage: "url('/h2.jpg')", // <-- put your image in public folder
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black opacity-40"></div>

      {/* Text content */}
      <div className="relative max-w-7xl mx-5 px-4 h-full flex items-center">
        <div className="text-white max-w-2xl md:ml-8">
          <h1 className="text-5xl md:text-6xl font-bold mb-4 leading-tight transition-all duration-700 ease-in-out">
            {slides[currentSlide].title}
          </h1>
          <p className="text-2xl md:text-3xl mb-8 text-gray-200 transition-all duration-700 ease-in-out">
            "{slides[currentSlide].subtitle}"
          </p>
          <button className="bg-orange-500  text-white px-8 py-3 rounded-full hover:bg-orange-600 transition-colors text-lg">
            Free Consultation
          </button>
        </div>
      </div>

     

      {/* Slide indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {slides.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentSlide(idx)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              currentSlide === idx
                ? "bg-orange-500 w-8"
                : "bg-white bg-opacity-50"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
